export class ScoreDTO {
    id: string;
    userCode?: string;
    points: number;
    description: string;
    deleted?: boolean;
    scoreDate: number[];
    expireDate: number[];

    constructor(id: string, points: number) {
        this.id = id;
        this.points = points;
        this.description = '';
        this.scoreDate = [];
        this.expireDate = [];
        this.deleted = false;
    }
}
